import React from "react";
import "../../css/homeView.css";
import Heading from "../../components/Heading";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import { SpiceDetails, DhoopDetails } from "../../Constants/productListConstant";
import Link from "gatsby-link";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import ReactPixel from "react-facebook-pixel";
import MediaQuery from "react-responsive";
import SlideItem from "../../components/SlideItem";
import { ProductCardsContainer } from "../../components/ProductCards";
import MarqueeText from "../../components/MarqueeText";
import LegacyOfTaste from "../../components/LegacyOfTaste";
import Testimonials from "../../components/Testimonials";
import "animate.css/animate.min.css";

// Constants
const FACEBOOK_PIXEL_ID = "145006083100066";
const TRANSITION_DURATION = 400;
const AUTOPLAY_SPEED = 10000;

// Image URLs
const IMAGES = {
  logo: "https://bawamasalacompany.com/assets/images/BMCHeaderLogo.png",
  hero: {
    desktop: [
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop1.png",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop2.png",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop3.png",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop4.png",
    ],
    mobile: [
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile1.jpeg",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile2.jpeg",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile3.jpeg",
      "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile4.jpeg",
    ],
  },
  buyNow: "https://bawamasalacompany.com/assets/images/Elements/Buy_Now_150x150.png",
};

// Slider configurations - ensure mobile and desktop have same settings
const SLIDER_SETTINGS = {
  hero: {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: AUTOPLAY_SPEED,
    centerMode: false,
    adaptiveHeight: true,
    arrows: true,
  },
  products: {
    desktop: {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: false,
          },
        },
      ],
    },
    mobile: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    },
  },
};

// Breakpoints
const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 992,
  DESKTOP: 1200,
};

export class HomeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slidesToShow: this.getInitialSlidesToShow(),
      defaultStyle: this.getInitialStyle(),
    };
  }

  componentDidMount() {
    this.initializeComponent();
  }

  componentWillUnmount() {
    this.cleanupComponent();
  }

  // Initialization methods
  initializeComponent = () => {
    this.updateWindowDimensions();
    this.setupEventListeners();
    this.initializeFacebookPixel();
    this.startTransition();
  };

  setupEventListeners = () => {
    window.addEventListener("resize", this.updateWindowDimensions);
  };

  initializeFacebookPixel = () => {
    try {
      ReactPixel.init(FACEBOOK_PIXEL_ID);
      ReactPixel.track("ViewContent", this.props.location);
    } catch (error) {
      console.warn("Facebook Pixel initialization failed:", error);
    }
  };

  startTransition = () => {
    setTimeout(() => {
      this.setState({
        defaultStyle: this.getTransitionedStyle(),
      });
    }, 500);
  };

  // Cleanup methods
  cleanupComponent = () => {
    window.removeEventListener("resize", this.updateWindowDimensions);
    this.setState({
      defaultStyle: this.getExitStyle(),
    });
  };

  // Style methods
  getInitialStyle = () => ({
    transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`,
    opacity: 0,
  });

  getTransitionedStyle = () => ({
    transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`,
    opacity: 1,
  });

  getExitStyle = () => ({
    transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`,
    opacity: 0.1,
  });

  // Window dimension methods
  getInitialSlidesToShow = () => {
    if (typeof window === "undefined") return 4;
    return this.calculateSlidesToShow(window.innerWidth);
  };

  calculateSlidesToShow = (width) => {
    if (width <= BREAKPOINTS.MOBILE) return 1;
    if (width <= BREAKPOINTS.TABLET) return 2;
    if (width <= BREAKPOINTS.DESKTOP) return 3;
    return 4;
  };

  updateWindowDimensions = () => {
    const newSlidesToShow = this.calculateSlidesToShow(window.innerWidth);

    if (this.state.slidesToShow !== newSlidesToShow) {
      this.setState({ slidesToShow: newSlidesToShow });
    }
  };

  // Render methods
  renderHeroSlider = (images, altPrefix) => (
    <Slider {...SLIDER_SETTINGS.hero}>
      {images.map((img, index) => (
        <div key={index} className="slider-slide" style={{ width: "100%" }}>
          <div className="home__slider">
            <img
              src={img}
              alt={`${altPrefix} banner image ${index + 1}`}
              className="hero-image"
              loading={index === 0 ? "eager" : "lazy"}
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </div>
        </div>
      ))}
    </Slider>
  );

  // Use identical rendering method for both desktop and mobile
  renderDesktopHero = () => (
    <MediaQuery query="(min-width: 769px)">
      <div className="home__copy__slider">
        <div className="slider__content">{this.renderHeroSlider(IMAGES.hero.desktop, "BMC desktop")}</div>
      </div>
    </MediaQuery>
  );

  renderMobileHero = () => (
    <MediaQuery query="(max-width: 768px)">
      <div className="home__copy__slider">
        <div className="slider__content">{this.renderHeroSlider(IMAGES.hero.mobile, "BMC mobile")}</div>
      </div>
    </MediaQuery>
  );

  renderProductsSection = () => {
    return (
      <div className="home__about">
        <Heading title="Bestselling Spices" />
        <div className="home__about__text">
          BMC Masalas offer a vast range of variety, tickling the taste buds of every food lover; whole spices, organic spices, spice mixes, spice blends and
          powders with exquisite aroma, texture and taste, in the Classic sizes, as well as new Mini Packs that make for ease, convenience and quick addition to
          flavour, taste and heat in all that is cooking!
        </div>
        <div className="buynow__logo">
          <img src={IMAGES.buyNow} alt="Buy Now" className="" />
        </div>
        <ProductCardsContainer maxItems={24} />
      </div>
    );
  };

  render() {
    const { defaultStyle } = this.state;
    const { location } = this.props;

    return (
      <ContentPage>
        <Meta
          title="Bawa Masala Company Estd. 1952 | India's Finest Spices & Spice Blends"
          description="Bawa Masala Company (BMC), established 1952, brings premium quality Indian spices and masala blends to kitchens and dealers nationwide."
          location={location}
        />
        <div className="global__wrapper" style={{ background: "#e9eef6", margin: 0, padding: 0 }}>
          <div className="home__wrapper" style={{ ...defaultStyle, margin: 0, padding: 0 }}>
            <MarqueeText />
            {this.renderDesktopHero()}
            {this.renderMobileHero()}
            <LegacyOfTaste />
            {this.renderProductsSection()}
            <Testimonials />
            <div className="product__conveyor" />
          </div>
        </div>
      </ContentPage>
    );
  }
}

export default HomeView;



// WEBPACK FOOTER //
// ./src/pages/home/index.js